module.exports = __webpack_public_path__ + "img/selected7-min.172d280c.png";